<!-- Hero Start -->
<section class="bg-half-170 bg-light d-table w-100" id="home">
  <div class="container">
    <div class="row mt-5 justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="pages-heading">
          <h4 class="title"> Hello! <br> How can we help you? </h4>

          <div class="subcribe-form mt-4 pt-2">
            <form>
              <div class="mb-0">
                <input type="text" id="help" name="name" class="border shadow rounded-pill" required=""
                  placeholder="Search your questions or topic...">
                <button type="submit" class="btn btn-pills btn-primary">Search</button>
              </div>
            </form>
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row-->

    <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/index">Landrick</a></li>
          <li class="breadcrumb-item"><a href="javascript:void(0)">Help Center</a></li>
          <li class="breadcrumb-item active" aria-current="page">Overview</li>
        </ul>
      </nav>
    </div>
  </div> <!--end container-->
</section><!--end section-->
<!-- Hero End -->

<!-- Start Section -->
<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="mb-4">Find the help you need</h4>
          <p class="para-desc mx-auto text-muted">Launch your campaign and benefit from our expertise on designing and
            managing conversion centered bootstrap v5 html page.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
        <div class="card features feature-primary explore-feature border-0 rounded text-center">
          <div class="card-body">
            <div class="icons rounded-circle shadow-lg d-inline-block mb-2 h3">
              <i class="uil uil-question-circle"></i>
            </div>
            <div class="content mt-4">
              <a routerLink="/helpcenter-faqs" class="title h5 text-dark">FAQs</a>
              <p class="text-muted mt-3 mb-0">Due to its widespread use as filler text for layouts, non-readability is
                of great importance.</p>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
        <div class="card features feature-primary explore-feature border-0 rounded text-center">
          <div class="card-body">
            <div class="icons rounded-circle shadow-lg d-inline-block mb-2 h3">
              <i class="uil uil-file-bookmark-alt"></i>
            </div>
            <div class="content mt-4">
              <a routerLink="/helpcenter-guides" class="title h5 text-dark">Guides / Support</a>
              <p class="text-muted mt-3 mb-0">Due to its widespread use as filler text for layouts, non-readability is
                of great importance.</p>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
        <div class="card features feature-primary explore-feature border-0 rounded text-center">
          <div class="card-body">
            <div class="icons rounded-circle shadow-lg d-inline-block mb-2 h3">
              <i class="uil uil-cog"></i>
            </div>
            <div class="content mt-4">
              <a routerLink="/helpcenter-support-request" class="title h5 text-dark">Support Request</a>
              <p class="text-muted mt-3 mb-0">Due to its widespread use as filler text for layouts, non-readability is
                of great importance.</p>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="mb-4">Get Started</h4>
          <p class="para-desc mx-auto text-muted">Launch your campaign and benefit from our expertise on designing and
            managing conversion centered bootstrap4 html page.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row justify-content-center">
      <div class="col-lg-9 mt-4 pt-2">
        <div class="faq-content">
          <div ngbAccordion #acc="ngbAccordion" activeIds="div ngbAccordionItem-0" closeOthers="true">
            <div ngbAccordionItem id="div ngbAccordionItem-0" cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="headingone">
                  <button ngbAccordionButton class="title mb-0"> How does it work </button>
                </div>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                <ng-template class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                  available, but
                  the majority have suffered alteration in some form.</ng-template>
                </div>
              </div>
           </div>
            <div ngbAccordionItem cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="headingtwo">
                  <button ngbAccordionButton class="title mb-0"> Do I need a designer to use Landrick ? </button>
                </div>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                <ng-template class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                  available, but
                  the majority have suffered alteration in some form.</ng-template>
                </div>
              </div>
           </div>
            <div ngbAccordionItem cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="headingthree">
                  <button ngbAccordionButton class="title mb-0"> What do I need to do to start selling ? </button>
                </div>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                <ng-template class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                  available, but
                  the majority have suffered alteration in some form.</ng-template>
                </div>
              </div>
           </div>
            <div ngbAccordionItem cardClass="border-0 rounded shadow mb-2">
              <h2 ngbAccordionHeader>
                <div class="border-0 bg-light" id="headingfour">
                  <button ngbAccordionButton class="title mb-0"> What happens when I receive an order ? </button>
                </div>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                <ng-template class="text-muted mb-0 faq-ans">There are many variations of passages of Lorem Ipsum
                  available, but
                  the majority have suffered alteration in some form.</ng-template>
                </div>
              </div>
           </div>
         </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-12">
        <div class="d-flex align-items-center features feature-clean shadow rounded p-4">
          <div class="icons text-primary text-center">
            <i class="uil uil-envelope-check d-block rounded h3 mb-0"></i>
          </div>
          <div class="flex-1 content ms-4">
            <h5 class="mb-1"><a href="javascript:void(0)" class="text-dark">Get in Touch !</a></h5>
            <p class="text-muted mb-0">This is required when, for text is not yet available.</p>
            <div class="mt-2">
              <a href="javascript:void(0)" class="btn btn-sm btn-soft-primary">Submit a Request</a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-6 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="d-flex align-items-center features feature-clean shadow rounded p-4">
          <div class="icons text-primary text-center">
            <i class="uil uil-webcam d-block rounded h3 mb-0"></i>
          </div>
          <div class="flex-1 content ms-4">
            <h5 class="mb-1"><a href="javascript:void(0)" class="text-dark">Start a Meeting</a></h5>
            <p class="text-muted mb-0">This is required when, for text is not yet available.</p>
            <div class="mt-2">
              <a href="javascript:void(0)" class="btn btn-sm btn-soft-primary">Start Video Chat</a>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- End Section -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->